import { ComponentProps } from "react"

import type { AnyFieldApi } from "@tanstack/react-form"

import { FormLabel } from "@/components/FormLabel"
import { FormInput } from "@/components/FormInput"
import { cn } from "@/lib/shadcn-utils"

interface FormFieldProps extends ComponentProps<"input"> {
  field: AnyFieldApi
  label: string
}

export function FormField({
  field,
  label,
  className,
  ...props
}: FormFieldProps) {
  return (
    <div className="tw-flex tw-flex-col tw-gap-1">
      <FormLabel field={field} label={label} className="tw-text-2xl" />
      <FormInput
        field={field}
        className={cn("tw-text-3xl tw-px-3 tw-py-2", className)}
        {...props}
      />
    </div>
  )
}
